

















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardExtrinsic extends Vue {
  @Prop({ default: false}) public open!: boolean;
  @Prop() public header!: any;
  @Prop() public content!: any;
  @Prop() public item1!: any;
  @Prop() public item1header!: any;
  @Prop() public item2!: any;
  @Prop() public item2header!: any;
  @Prop() public item3!: any;
  @Prop() public item3header!: any;
}
